




























































import Vue from 'vue';
import { mapGetters } from 'vuex';

import Address from '@/types/Address';

import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';
import HorizontalField from '@/components/Bulma/HorizontalField.vue';

export default Vue.extend({
    name: 'Address',

    components: {
        Field,
        TInput,
        HorizontalField
    },

    props: {
        value: Object as () => Address,
        readonly: Boolean
    },

    computed: {
        ...mapGetters(['getShippingCountries']),

        address: {
            get(): Address {
                return this.value;
            }
        }
    },

    watch: {
        address: {
            handler(address: Address) {
                this.$emit('input', address);
            },
            deep: true
        }
    }
});
